import React from 'react';
import { Link } from 'react-router-dom';
import { portfolioData } from '../data/portfolioData';

const Work = () => {
  return (
    <div className="work container">
      <p className="eyebrow">Case Studies</p>
      <h1>Projects where product UI, design systems, and implementation meet.</h1>
      <p className="work-intro">
        Some started with a rough prototype. Others started with a workflow that needed untangling. Here's what I tried, what worked, and what still needed more work.
      </p>

      <div className="project-list">
        {portfolioData
          .filter((project) => !project.hidden)
          .map((project, idx) => (
          <Link
            key={idx}
            to={`/work/${project.alias}`}
            className="project-item"
          >
            {project.mainImg && (
              <div className="project-thumbnail">
                <img
                  src={project.mainImg}
                  alt={`${project.title} - ${project.subtitle || 'project screenshot'}`}
                />
              </div>
            )}
            <article className="project-content">
              <h2>{project.title}</h2>
              <p className="project-subtitle">{project.subtitle}</p>
              {project.duration && <p className="project-duration">{project.duration}</p>}

              <div className="project-tags">
                {project.tag.map((tag, i) => (
                  <span key={i}>
                    {tag}
                    {i < project.tag.length - 1 && ' ·'}
                  </span>
                ))}
              </div>
            </article>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Work;
